import { Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Equipment } from 'src/models';
import { formatDashboardEquipment } from 'src/helpers/equipment';
import { useState } from 'react';

interface CardEquipmentProps {
  size?: 'small' | 'large';
  equipments: Equipment[][];
}

const useStyles = makeStyles<Theme, { size: 'small' | 'large' }>((theme) => ({
  equipmentContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '456px',
  },
  equipmentRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
    marginRight: 8,
  },
  equipmentDescription: {
    color: theme.palette.text.primary,
    fontSize: ({ size }) => (size === 'small' ? 16 : 20),
    fontWeight: ({ size }) => (size === 'small' ? 400 : 600),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
  },
  image: {
    width: ({ size }) => (size === 'small' ? 24 : 48),
    marginRight: ({ size }) => (size === 'small' ? 8 : 0),
    flexShrink: 0,
  },
  equipmentQuantity: {
    fontWeight: 400,
    color: theme.palette.text.primary,
    flexShrink: 0,
  },
}));
const CardEquipment = ({ equipments, size = 'small' }: CardEquipmentProps) => {
  const classes = useStyles({ size });
  const formattedEquipments = formatDashboardEquipment(equipments);
  const [imageErrors, setImageErrors] = useState<Record<string, boolean>>({});

  const handleImageError = (model: string) => {
    setImageErrors((prev) => ({ ...prev, [model]: true }));
  };

  return (
    <div className={classes.equipmentContainer}>
      {formattedEquipments.map((equipments, index) => {
        return equipments.map((equipment) => {
          if (equipment.model) {
            return (
              <div className={classes.equipmentRow} key={equipment.model + index}>
                <div className={classes.textContainer}>
                  {equipment.image && !imageErrors[equipment.model] && (
                    <img
                      src={equipment.image}
                      alt={equipment.model}
                      className={classes.image}
                      onError={() => handleImageError(equipment.model)}
                    />
                  )}
                  <Typography variant="body2" className={classes.equipmentDescription} noWrap>
                    {equipment.model}
                  </Typography>
                </div>
                {equipment.quantity > 1 && (
                  <Typography variant="body2" className={classes.equipmentQuantity}>
                    x{equipment.quantity}
                  </Typography>
                )}
              </div>
            );
          }
          return null;
        });
      })}
    </div>
  );
};

export default CardEquipment;
